import { InputField } from '@/modules/base';
import { useIntl } from 'react-intl';
import React, { useEffect, useState } from 'react';
import { useInteractionState } from '@/hooks';
import { sumWithDeliveryFee } from '@/service';
import { isEmpty } from 'lodash';
import { Customer } from '@/type/custom';

export const ShopCartContactFormComponent = () => {
  const { orders, customer, setCustomer, management } = useInteractionState();
  const intl = useIntl();

  const [errors, setErrors] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    const errors: Record<string, boolean> = {};
    //Name
    if (!customer?.name) {
      errors.name = true;
    }
    //Email
    if (customer?.email) {
      const lastAtPos = customer.email.lastIndexOf('@');
      const lastDotPos = customer.email.lastIndexOf('.');
      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          customer.email.indexOf('@@') === -1 &&
          lastDotPos > 2 &&
          customer.email.length - lastDotPos > 2
        )
      ) {
        errors.email = true;
      }
    }
    //Telephone
    if (!customer?.telephone) {
      errors.telephone = true;
    }
    const { price } = sumWithDeliveryFee(orders, customer?.postal);
    //Price
    if (!price) {
      errors.price = true;
    }
    setErrors({ ...errors });
  }, [customer, orders]);

  const handleFieldValueChange = <Key extends keyof Customer>(
    field: Key,
    value: Customer[Key]
  ) => {
    const currentCustomer = { ...customer };
    currentCustomer[field] = value;
    if (!currentCustomer['city']) {
      currentCustomer['city'] = 'München';
    }
    setCustomer?.(currentCustomer);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const enterMessages = (e: any) => {
    const currentCustomer = { ...customer };
    currentCustomer.message = e.target.value;
    setCustomer?.(currentCustomer);
  };

  return (
    <div className="inner">
      <div className="contact-form contact">
        <div className="col-md-6 ">
          <InputField
            item={{
              id: 'app.contact.name',
              type: 'text',
              defaultMessage: 'Name',
              value: customer?.name ?? '',
              field: 'name',
              className: 'form',
              error: errors['name'],
            }}
            onChange={handleFieldValueChange}
          />
          <InputField
            item={{
              id: 'app.contact.address',
              type: 'text',
              defaultMessage: 'Address',
              value: customer?.address ?? '',
              field: 'address',
              className: 'form',
              error: errors['address'],
            }}
            onChange={handleFieldValueChange}
          />
          <InputField
            item={{
              id: 'app.contact.email',
              type: 'text',
              defaultMessage: 'Email',
              value: customer?.email ?? '',
              field: 'email',
              className: 'form',
              error: errors['email'],
            }}
            onChange={handleFieldValueChange}
          />
          <div className="row">
            <div className="col-md-4">
              <InputField
                item={{
                  id: 'app.contact.postal',
                  type: 'text',
                  defaultMessage: 'Postal',
                  value: customer?.postal ?? '',
                  field: 'postal',
                  className: 'form',
                  error: errors['postal'],
                }}
                onChange={handleFieldValueChange}
              />
            </div>
            <div className="col-md-8">
              <InputField
                item={{
                  id: 'app.contact.city',
                  type: 'text',
                  defaultMessage: 'City',
                  value: customer?.city ?? '',
                  field: 'city',
                  className: 'form',
                  error: errors['city'],
                  disabled: true,
                }}
                onChange={handleFieldValueChange}
              />
            </div>
          </div>
          <InputField
            item={{
              id: 'app.contact.telephone',
              type: 'text',
              defaultMessage: 'Telephone',
              value: customer?.telephone ?? '',
              field: 'telephone',
              className: 'form',
              error: errors['telephone'],
            }}
            onChange={handleFieldValueChange}
          />
        </div>
        <div className="col-md-6">
          <textarea
            name="message"
            className="form textarea"
            rows={10}
            value={customer?.message}
            onChange={(event) => enterMessages(event)}
            placeholder={intl.formatMessage({
              id: 'app.contact.wish',
              defaultMessage: 'wish',
            })}
            style={{
              borderColor: errors['message'] ? 'red' : '',
            }}
          />
        </div>
        <div className="relative fullwidth col-xs-12">
          <button
            type="submit"
            style={{
              color:
                !isEmpty(errors) || !!management?.email_disable
                  ? '#808080'
                  : '',
            }}
            disabled={!isEmpty(errors) || !!management?.email_disable}
            className="form-btn"
            data-toggle="modal"
            data-target="#orderConfirm"
          >
            {intl.formatMessage({ id: 'app.cart.confirm' })}
          </button>
        </div>
        <div className="clear" />
      </div>
    </div>
  );
};
